import React, { useState } from 'react';
import StatementUpload from './StatementUpload';
import TransactionManagement from './TransactionManagement';

const StatementManagement = ({ receiptIdFromUrl, onReceiptProcessed, isViewer }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showUploadModal, setShowUploadModal] = useState(false);

  const handleUploadSuccess = (uploadResult) => {
    // Trigger refresh of transaction list
    setRefreshTrigger(prev => prev + 1);
    // Close the modal after successful upload
    setShowUploadModal(false);
  };

  const handleCloseModal = () => {
    setShowUploadModal(false);
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4 sm:mb-0">Credit Card Statements</h1>
        {!isViewer && (
          <button
            className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-lg transition-colors duration-200"
            onClick={() => setShowUploadModal(true)}
          >
            Upload Statement
          </button>
        )}
      </div>
      
      {/* Upload Modal */}
      {showUploadModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center p-4" onClick={handleCloseModal}>
          <div className="bg-white rounded-xl shadow-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h3 className="text-xl font-semibold text-gray-900">Upload Credit Card Statement</h3>
              <button 
                className="text-gray-400 hover:text-gray-600 text-2xl font-bold" 
                onClick={handleCloseModal}
              >
                ×
              </button>
            </div>
            <StatementUpload onUploadSuccess={handleUploadSuccess} />
          </div>
        </div>
      )}
      
      {/* Transaction Management Section */}
      <TransactionManagement refreshTrigger={refreshTrigger} receiptIdFromUrl={receiptIdFromUrl} onReceiptProcessed={onReceiptProcessed} isViewer={isViewer} />
    </div>
  );
};

export default StatementManagement;